import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { RootStores } from '@portal/env/stores/RootStores';

/**
 * Get access to the global mobx stores as defined on the context.
 *
 * This is a bit of an anti-pattern, we're not supposed to be using mobx globally like this,
 * but it's how it was architected when portal was created by Nexudus
 */
export const useMobxStores = () => {
  const stores = useContext(MobXProviderContext) as
    | RootStores
    | undefined
    | null;
  if (!stores) {
    throw new Error('useMobxStores must be used within a MobX Provider');
  }
  return stores;
};
